export default __webpack_public_path__ + "static/media/jumper1.3244d53b.png";